'use client'

import { Skeleton } from '@morpho-org/ui-v6/server'
import { cn } from '@morpho-org/ui-v6/utils'
import { AnimatePresence, motion } from 'motion/react'

import { CardAnimationWrapper } from '../CardAnimationWrapper'
import { getCardNetApyConfig } from '../CardNetApy.config'

export interface CardLoadingProps {
  isExpanded?: boolean
  small?: boolean
}

const CardLoading = ({ isExpanded, small }: CardLoadingProps) => {
  const { background } = getCardNetApyConfig(small, isExpanded)

  return (
    <CardAnimationWrapper isExpanded={isExpanded} isSmall={small}>
      <div
        className={cn(
          // Padding matches CardNetApyHeaderWrapper so the bars sit where the
          // label/value land; small mobile also matches the breakdown below it.
          'flex flex-[1px] flex-col h-full w-full gap-lg shrink-0 rounded-[20px] px-md',
          `py-md max-md:py-lg ${background}`,
          small && 'max-md:gap-md max-md:pb-md'
        )}
      >
        <div className="flex items-center justify-between">
          <div className="gap-xs flex flex-col">
            <Skeleton className="h-md w-[55px] rounded-[20px] max-md:h-4" />
            <Skeleton className="h-[24px] w-[55px] rounded-[20px]" />
          </div>
          <div className="gap-xs flex flex-row">
            <Skeleton className="h-lg w-[82px] rounded-[20px]" />
            <Skeleton className="h-lg w-[86px] rounded-[20px]" />
          </div>
        </div>
        <AnimatePresence mode="sync" initial={false}>
          {(small || isExpanded) && (
            <motion.div
              key="card-net-apy-loading"
              initial={{ opacity: 0, height: 0, z: 0 }}
              animate={{ opacity: 1, height: '100%', z: 0 }}
              exit={{ opacity: 0, height: 0, z: 0 }}
              transition={{ duration: 0.2 }}
            >
              <div className={cn('gap-sm flex flex-col', small && 'max-md:gap-[28px]')}>
                <Skeleton className="h-lg rounded-[20px]" />
                <Skeleton className="h-lg rounded-[20px]" />
                <Skeleton className="h-lg rounded-[20px]" />
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </CardAnimationWrapper>
  )
}

export default CardLoading
